angular.module('ui.order.stepDetailed', [])

    .directive('stepDetailed', function () {
        return {
            restrict: "E",
            templateUrl: 'app/ui/order/stepDetailedView/stepDetailed/stepDetailed.html',
            scope: {},
            controller: 'StepDetailedController',
            controllerAs: 'StepDetailedController'
        };
    })

    .controller('StepDetailedController', function ($scope, $state, $q, $log, toastr, gettextCatalog, orderItemsGridSharedSettings,
                                                    gridDataProvider, stepDetailedControllerUpdatesService,
                                                    usersRepository, workflowRepository, $customisationConfig,
                                                    serverLocalization, uiLocalization) {
        $scope.isDataLoaded = false;
        $scope.isOrderItemDataLoaded = false;

        $scope.step = orderItemsGridSharedSettings.getStepFilter() || 'all-open';
        $scope.pageNumber = orderItemsGridSharedSettings.getPageNumber();
        if (!$scope.pageNumber) {
            $scope.pageNumber = 1;
            orderItemsGridSharedSettings.setPageNumber(1);
        }

        _.extend($scope, {
            toFirstPage: toFirstPage,
            toPrevPage: toPrevPage,
            toNextPage: toNextPage,
            toLastPage: toLastPage,

            selectOrderItem: selectOrderItem,

            onOrderItemLoadStart: onOrderItemLoadStart,
            onOrderItemLoadEnd: onOrderItemLoadEnd,
            onOrderItemActionExecute: onOrderItemActionExecute,
            onOrderItemActionExecuteStart: onOrderItemActionExecuteStart
        });

        initController();

        function initController() {
            initStepHeader();
            reloadList();
            initWatchers();
        }

        function initWatchers() {
            stepDetailedControllerUpdatesService.onOrderItemChanged(function () {
                reloadList();
            });
            stepDetailedControllerUpdatesService.onOrderChanged(function () {
                reloadList();
            });
            stepDetailedControllerUpdatesService.onNewOrderItem(function () {
                reloadList();
            });

            $scope.$on(
                "$destroy",
                function () {
                    stepDetailedControllerUpdatesService.onOrderItemChanged(null);
                    stepDetailedControllerUpdatesService.onNewOrderItem(null);
                    stepDetailedControllerUpdatesService.onOrderChanged(null);
                }
            );
        }

        /**
         * Select orderItem
         * @param {RepresentationModel} orderItem model
         */
        function selectOrderItem(orderItem) {
            $scope.orderItemId = orderItem ? orderItem.getId() : null;
            orderItemsGridSharedSettings.setSelectedOrderItemId($scope.orderItemId);

            var lastSelected = _.findIndex($scope.orderItems, function (rm) {
                return rm.getId() === $scope.orderItemId;
            });
            if (lastSelected < 0) {
                lastSelected = 0;
            }
            lastSelectedIndex = lastSelected;
        }

        function onOrderItemLoadStart() {
            $scope.isOrderItemDataLoaded = false;
        }

        function onOrderItemLoadEnd() {
            $scope.isOrderItemDataLoaded = true;
        }

        var isOrderItemActionExecuting = false;

        function onOrderItemActionExecuteStart() {
            isOrderItemActionExecuting = true;
        }

        function onOrderItemActionExecute() {
            isOrderItemActionExecuting = false;
            return reloadList();
        }

        /**
         * Reload order items list
         */
        function reloadList() {
            if (isOrderItemActionExecuting) {
                return;
            }
            $scope.isDataLoaded = false;
            orderItemsGridSharedSettings.setPageNumber($scope.pageNumber);
            lastPageNumber = $scope.pageNumber;

            return gridDataProvider.getData()
                .then(function (searchResults) {
                    $scope.orderItems = searchResults.items;

                    $scope.pageNumber = orderItemsGridSharedSettings.getPageNumber();
                    $scope.totalPageCount = searchResults.totalPageCount;

                    fixSelection(searchResults);
                    $scope.orderItemId = orderItemsGridSharedSettings.getSelectedOrderItemId();

                    $scope.isDataLoaded = true;

                    if (searchResults.totalCount === 0 && searchResults.items.length === 0) {
                        // todo sound notification
                        if (orderItemsGridSharedSettings.isClear()) {
                            toastr.info(gettextCatalog.getString("Going back to the home screen..."), gettextCatalog.getString("No order items to display at current step"));
                            orderItemsGridSharedSettings.clear();
                            $state.go('client.home', {
                                step: $scope.step
                            });
                        } else {
                            toastr.info(gettextCatalog.getString("Going back to the grid..."), gettextCatalog.getString("No order items to display"));
                            orderItemsGridSharedSettings.clear();
                            $state.go('client.orders', {
                                step: $scope.step
                            });
                        }
                    }
                }, function (err) {
                    $scope.isDataLoaded = true;
                    $log.error("Can't load data for list in stepDetailed view. Cause: %s", err.message);
                    toastr.error(err.message, gettextCatalog.getString("Can't load list of order items"));
                });
        }

        var lastSelectedIndex;
        var lastPageNumber;

        function fixSelection(resp) {
            if (resp.items.length > 0) {
                var selectedId = orderItemsGridSharedSettings.getSelectedOrderItemId();

                if (selectedId) {
                    var lastSelected = _.findIndex(resp.items, function (rm) {
                        return rm.getId() === selectedId;
                    });
                    if (lastSelected >= 0) {
                        lastSelectedIndex = lastSelected;
                    } else {
                        if (lastPageNumber && lastPageNumber != orderItemsGridSharedSettings.getPageNumber()) {
                            lastSelectedIndex = resp.items.length - 1;
                        }
                    }
                }
                if (!lastSelectedIndex || lastSelectedIndex < 0) {

                    lastSelectedIndex = 0;
                }
                if (lastSelectedIndex >= resp.items.length) {
                    lastSelectedIndex = resp.items.length - 1;
                }

                orderItemsGridSharedSettings.setSelectedOrderItemId(resp.items[lastSelectedIndex].getId())
            } else {
                lastSelectedIndex = null;
                orderItemsGridSharedSettings.setSelectedOrderItemId(null);
            }
        }

        /**
         * Method to collect/construct data necessary to render corresponding step icon/button in the header of the nav bar
         * @returns {Promise}
         */
        function initStepHeader() {
            $scope.stateDisplayName = "";
            $scope.stateIconName = "";

            return $q.all(
                [
                    usersRepository.getCurrentUser(),
                    workflowRepository.getSteps()
                ]
            ).then(function (data) {
                    var stepDisplayName = "All Items";

                    var isCustomer = data[0].isCustomer();
                    var step = _.find(data[1], function (s) {
                        return s.$model.code === $scope.step;
                    });
                    var stepConfig = _.find($customisationConfig.workflow.steps, function (s) {
                        return s.code === $scope.step;
                    });

                    if (step) {
                        stepDisplayName = isCustomer ? step.$model.publicNameResource : step.$model.nameResource;
                    }

                    var fallbackIconForStep = function (stepCode) {
                        return $customisationConfig.hasResource(function (res) {
                            return _.string.contains(res, stepCode + ".");
                        }) ? stepCode : "workflow";
                    };

                    if ($scope.step && $scope.step !== "all-open") {
                        $scope.stateDisplayName = serverLocalization.translate(stepDisplayName);
                    } else {
                        $scope.stateDisplayName = gettextCatalog.getString("All Items");
                    }

                    $scope.stateIconName = angular.isUndefined(stepConfig) ? fallbackIconForStep($scope.step) :
                        (angular.isDefined(stepConfig.publicImageResourceName) && isCustomer
                            ? stepConfig.publicImageResourceName
                            :
                            (angular.isDefined(stepConfig.imageResourceName) ? stepConfig.imageResourceName :
                                fallbackIconForStep($scope.step)));
                });
        }

        function toFirstPage() {
            if (!$scope.isDataLoaded) {
                return;
            }
            $scope.pageNumber = 1;
            reloadList();
        }

        function toPrevPage() {
            if (!$scope.isDataLoaded) {
                return;
            }
            $scope.pageNumber = $scope.pageNumber - 1;
            if ($scope.pageNumber <= 0 || $scope.pageNumber > $scope.totalPageCount) {
                $scope.pageNumber = 1;
            }
            reloadList();
        }

        function toNextPage() {
            if (!$scope.isDataLoaded) {
                return;
            }
            $scope.pageNumber = $scope.pageNumber + 1;
            if ($scope.pageNumber <= 0 || $scope.pageNumber > $scope.totalPageCount) {
                $scope.pageNumber = $scope.totalPageCount;
            }
            reloadList();
        }

        function toLastPage() {
            if (!$scope.isDataLoaded) {
                return;
            }
            $scope.pageNumber = $scope.totalPageCount;
            reloadList();
        }
    })

    // Separate service for update events (to prevent multiple event subscription)
    .service('stepDetailedControllerUpdatesService', function (rest) {
        var _this = this;
        var newOrderItemCb;
        var orderItemChangedCb;
        var orderChangedCb;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!newOrderItemCb) {
                return;
            }
            if (modelInfo && modelInfo.modelType == "OrderItemModel") {
                newOrderItemCb(modelInfo);
            }
        });

        rest.events.on("modelUpdatedOnServer", function (modelInfo) {
            if (modelInfo.modelType == "OrderItemModel" && orderItemChangedCb) {
                orderItemChangedCb(modelInfo);
            } else if (modelInfo.modelType == "OrderModel" && orderChangedCb) {
                orderChangedCb(modelInfo);
            }
        });

        _this.onNewOrderItem = function (cb) {
            newOrderItemCb = cb;
        };

        _this.onOrderItemChanged = function (cb) {
            orderItemChangedCb = cb;
        };

        _this.onOrderChanged = function (cb) {
            orderChangedCb = cb;
        };

        return _this;
    })

;